<template>
  <b-card class="border-none">
    <b-input-group class="">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        v-model="search"
        @input="dataLoad"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
          @click="dataLoad()"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color table-textcenter"
      :data="getAllPodcast.result"
      border
    >
      <el-table-column
        label="Title"
        min-width="180px"
        prop="title"
        class="ml-12"
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.name }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Description" prop="description" min-width="180px">
        <template v-slot="{ row }">
          <p
            class="font-semibold text-left name mb-0 text-sm ellipsis-3"
            v-html="row.description"
          ></p>
        </template>
      </el-table-column>
      <el-table-column label="Category" prop="category" min-width="180px">
        <template v-slot="{ row }">
          <p class="font-semibold name mb-0 text-sm text-center cursor-pointer">
            {{ row.categoryId.name }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="Total Podcasts"
        prop="episode_count"
        min-width="120px"
      >
        <template v-slot="{ row }">
          <div class="flex justify-center items-center gap-3">
            <p class="font-semibold name mb-0 text-sm text-center">
              {{ row.episode_count }}
            </p>
            <feather-icon
              icon="LogInIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="
                handleRedirect('podcast-episode', row._id, row.categoryId._id)
              "
            ></feather-icon>
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column label="Images" prop="title" sortable>
        <template v-slot="{ row }" class="">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.Images }}
          </p>
        </template>
      </el-table-column>

      <el-table-column label="Attachments" prop="title" sortable>
        <template v-slot="{ row }" class="">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.Attachments }}
          </p>
        </template>
      </el-table-column> -->

      <el-table-column
        label="Actions"
        min-width="120px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="totalPages"
        @change="handlePageChange"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
} from "element-ui";

import { mapState } from "vuex";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 8,
      search: "",
      totalPages: 0,
    };
  },
  computed: {
    // ...mapState("cms", {
    //   categorywisepages: "categorywisepages",
    //   selectedpagecategory: "selectedpagecategory",
    // }),
    // displayedPages() {
    //   return this.categorywisepages.data.slice(
    //     (this.currentPage - 1) * this.perPage,
    //     this.currentPage * this.perPage
    //   );
    // },
    // totalPages() {
    //   return this.categorywisepages.data.length;
    // },
    ...mapState("podcast", { getAllPodcast: "getAllPodcast" }),
  },
  methods: {
    async dataLoad() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage * this.perPage,
        search: this.search,
      };

      await this.$store.dispatch("podcast/getall_podcast", payload);
      this.totalPages = this.getAllPodcast.totalCount;
    },
    handleRedirect(val, pid, cid) {
      this.$router.push({
        name: val,
        query: {
          pid: pid,
          cid: cid,
        },
      });
    },
    toKebabCase(string) {
      return string.toLowerCase().replace(/\s/g, "-");
    },
    toTitleCase(string) {
      return (
        string &&
        string.slice(0, 1).toUpperCase() + string.slice(1).toLowerCase()
      );
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = { podcastId: row._id };
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch(
          "podcast/delete_podcast",
          payload
        );
        this.dataLoad();
        // console.log(data.code);
        loader.close();
        if (data.code === 200) {
          this.$swal({
            text: "Podcast deleted successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
      } catch (error) {
        loader.close();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.dataLoad();
    },
    async handleEdit(scope) {
      let { row } = scope;
      this.$router.push({ name: "editPodcast" });
      await this.$store.commit("podcast/SELECTED_PODCAST", row);
    },
  },
  async mounted() {
    // this.currentPage = 0;
    // let payload = {
    //   offset: 0,
    //   id: "61adf7f010718313e80bcc4b",
    //   limit: 10,
    //   updatedAt: true,
    //   isActive: false,
    // };
    // this.filteredData = await this.$store.dispatch(
    //   "cms/GetPagesbyCategoryForBlog",
    //   payload
    // );
    this.dataLoad();
    // this.$store.dispatch("cms/getpagebycategory", {
    //   id: "61adf7ec10718313e80bcc4a",
    // });
  },
};
</script>

<style scoped>
.clr606266 {
  color: #606266;
}
</style>
